var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('BaseContent',{attrs:{"title":"Your Artists"}},[_c('BaseSection',{attrs:{"padded":""}},[(_vm.artistsList.length)?_c('ArtistBlock',{attrs:{"artists":_vm.artistsList,"should-transition":_vm.shouldTransition,"wrapping":"","wrapping-mobile":"","is-indexed-list":""}}):_c('BaseEmptyList',{attrs:{"error":{
                    title: `You are not following any artists.`,
                    paragraph: 'Following artists helps us recommend similar artists.',
                }}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }